import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import { aboutPageAssets } from "../../assets/media"
import Layout from '../../layout'
import { toTitleCase } from "../../services/helpers/helpers.js"

import StyledButton from '../../components/layout_components/StyledButton'
import ImageMap from '../../components/pages_components/about/ImageMap'

import { TiWorld } from 'react-icons/ti'
import { FaHandshake, FaUserAlt } from 'react-icons/fa'
import { IoGameController } from 'react-icons/io5'
import { truncateString } from '../../services/helpers/helpers.js'
import FeaturedSliderComponent from '../../components/pages_components/about/featuredSliderComponent/FeaturedSliderComponent'

const About = () => {

    const {
        bannerArtScreen,
    } = aboutPageAssets

    const { ai, pa, ns, gm, lt, bp } = aboutPageAssets
    const quirks = [
        {
            name: "Arificial Intelligence",
            url: ai
        },
        {
            name: "Predictive Analysis",
            url: pa
        },
        {
            name: "Neuro Science",
            url: ns
        },
        {
            name: "Gamification",
            url: gm
        },
        {
            name: "Latest Technologies",
            url: lt
        },
        {
            name: "Best Practices",
            url: bp
        },
    ]

    const { craft, capterra, g2, crozdeck, softSuggest } = aboutPageAssets
    const hrMarketPlaces = [
        {
            caption: "Craft.co",
            url: craft
        },
        {
            caption: "Capterra",
            url: capterra
        },
        {
            caption: "G2",
            url: g2
        },
        {
            caption: "Crozdeck",
            url: crozdeck
        },
        {
            caption: "Software Suggest",
            url: softSuggest
        },
    ]



    const statsData = [
        {
            name: "Candidate Assessments",
            value: "750,000+",
            imgSrc: <IoGameController className='w-[1.5rem] h-[1.5rem] 2xl:mr-2 lg:mr-1 text-[#FFB701] hidden lg:block' />,
            imgSrc2: <IoGameController className='w-[55px] h-[68px] mx-auto text-[#ffd700] lg:hidden' />
        },
        {
            name: "Global Clients",
            value: "50+",
            imgSrc: <FaUserAlt className='text-[1.2rem] 2xl:mr-2 lg:mr-1 text-[#FFB701] hidden lg:block' />,
            imgSrc2: <FaUserAlt className='w-[55px] h-[68px] mx-auto text-[#ffd700] lg:hidden' />
        },
        {
            name: "Countries",
            value: "170+ ",
            imgSrc: <TiWorld className='w-[1.5rem] h-[1.5rem] 2xl:mr-2 lg:mr-1 text-[#FFB701]  hidden lg:block' />,
            imgSrc2: <TiWorld className='w-[55px] h-[68px] mx-auto text-[#ffd700] lg:hidden' />
        },
        {
            name: "Partners",
            value: "10+",
            imgSrc: <FaHandshake className='w-[1.5rem] h-[1.5rem] 2xl:mr-2 lg:mr-1 text-[#FFB701] hidden lg:block' />,
            imgSrc2: <FaHandshake className='w-[55px] h-[68px] mx-auto text-[#ffd700] lg:hidden' />
        },
    ]

    const aboutOrgDesc = "The Talent Games is now empowering companies and their recruiting teams with ready-to-launch gamified tests on a pay-as-you-go basis. As a recruiter, now you don’t have to worry about the invoicing or need any assistance from our team to create and launch your tests. To get started, sign up for a Free Trial (no credit card required) and see how gamified tests can transform your whole hiring experience."
    const truncatedDesc = truncateString(aboutOrgDesc, 170)
    const [isExpand, setisExpand] = useState(false)
    const [aboutDesc, setaboutDesc] = useState(truncatedDesc)

    const handleReadMore = () => {
        if (!isExpand) {
            setaboutDesc(aboutOrgDesc)
        } else {
            setaboutDesc(truncatedDesc)
        }
        setisExpand(!isExpand)
    }



    return (
        <Layout>
            <div className="about relative">
                <div className="wrapper">
                    {/* hero section */}
                    <div className={`heroWrapper relative w-[23rem] sm:w-[40rem] lg:w-[95vw] mx-auto md:bg-about-hero-pattern bg-center bg-cover`}>


                        <div className="hero  z-50 relative my-5 sm:w-[35rem]  lg:w-[80vw] w-full mx-auto sm:h-[16rem] md:h-[18rem]  lg:h-[18rem] lg:p-5 2xl:h-[30rem] flex flex-col justify-center">
                            <div className="heroTexts text-center lg:w-[45rem] mx-auto xl:w-[900px] 2xl:w-[1124px] 2xl:mb-10">

                                {/* title */}
                                <h1 className='text-[1.5rem] text-center sm:text-center lg:text-[2rem] font-bold lg:text-center lg:leading-[2.5rem] 2xl:text-[48px] 2xl:!leading-[60px] 2xl:font-[700] lg:w-[35rem] mx-auto 2xl:w-[55rem] xl:font-[700] xl:text-[2.5rem] xl:leading-[3rem] xl:w-[52rem] text-[#333333]'>We Are Bridging The Gap Between Employers & Candidates</h1>

                                {/* description Desktop */}
                                <p className='mt-5 hidden md:block lg:text-center text-[16px] lg:text-sm sm:text-center sm:text-xs 2xl:text-[22.2px] 2xl:leading-[40px] leading-[32px] text-center '>{aboutOrgDesc}</p>
                                {/* Description mobile */}
                                <p className='mt-5 px-2 md:hidden lg:text-center text-[16px] lg:text-sm sm:text-center sm:text-xs 2xl:text-[22.2px] 2xl:leading-[40px] leading-[32px] text-center '>{aboutDesc}</p>

                                <StyledButton btnText={`${isExpand ? 'Read Less' : 'Read More'}`} customStyle={`my-12 md:hidden !py-3 !px-1 !w-[150px] !text-xs font-semibold`} btnEventHandler={handleReadMore} />

                            </div>

                        </div>

                    </div>

                    {/* banner 1 */}
                    <div className="quirksbanner bg-[#FFD700] ">

                        <div className="bannerWrapper flex flex-col items-center py-10 w-[23rem] sm:w-[40rem] lg:w-[80vw] mx-auto">

                            <h4 className='text-[24px] font-bold text-center 2xl:text-[40px]'>What Makes Us The Leading Gamified Tests Provider</h4>

                            <div className="quirks flex flex-wrap w-[23rem] mt-5 sm:w-[22rem] lg:w-[30rem] justify-center 2xl:w-[850px]">
                                {
                                    quirks.map((quirk, index) =>
                                    (
                                        <img key={`imgQuirk${quirk.name}${index}`} src={quirk.url} className="object-contain h-[150px] sm:h-[90px] m-4 2xl:h-[12rem] mx-4 2xl:mx-10" alt="" />
                                    )
                                    )
                                }
                            </div>
                        </div>

                    </div>

                    {/* banner2 */}
                    <div className="hrMarketPlaceBanner bg-white ">

                        <div className="banner2Wrapper flex flex-col items-center py-8 w-[23rem] sm:w-[40rem] lg:w-[80vw] mx-auto 2xl:mt-14">

                            <h4 className='text-2xl font-bold text-center 2xl:text-[48px] 2xl:leading-[64px]'>Featured on Top HR Market Places</h4>

                            <div className="places hidden lg:flex flex-wrap w-[23rem] sm:w-[25rem] lg:w-[30rem] justify-around lg:justify-between mt-10 2xl:w-[60rem] 2xl:my-20">
                                {
                                    hrMarketPlaces.map((place, index) =>
                                    (
                                        <div key={`divMarketPlace${place.caption}${index}`} className='flex flex-col items-center px-2 w-[6rem] sm:w-[6.5rem] md:w-[7rem] lg:w-fit'>

                                            <img src={place.url} className="object-contain h-[64px] lg:h-[2rem] mx-5 my-5 lg:my-0 lg:mx-4 2xl:w-[64px] 2xl:h-[64px]" alt="" />
                                            <p className='text-[20px] lg:text-[12px] font-semibold text-center mt-1 2xl:text-[20px] 2xl:leading-[26px]'>{place.caption}</p>
                                        </div>
                                    )
                                    )
                                }
                            </div>
                        </div>

                    </div>
                    <FeaturedSliderComponent />

                    {/* section 2 image map */}

                    <ImageMap />


                    {/* image map end */}

                    {/* banner 3 */}
                    <div className="theNumberGame pb-40 pt-20 sm:py-14 sm:w-full  lg:w-full mx-auto">
                        {/* <div className="art2 w-full  lg:hidden">
                            <img className='h-30 object-contain mb-10 sm:mb-0' src={bannerArt2} alt="" />
                        </div> */}
                        <h4 className='text-[24px] text-center lg:text-left lg:text-[2.1rem] font-bold w-[20rem] sm:w-[20rem] mx-auto 2xl:text-[46px] 2xl:leading-[71px] 2xl:w-[30rem] 2xl:text-center'>The Number Game</h4>


                        <div className="statsBanner  flex flex-col lg:flex-row lg:justify-center lg:items-center py-6 items-center w-[20rem] sm:w-[25rem] sm:justify-around sm:flex-wrap sm:flex-col lg:w-[50rem] xl:w-[70rem] mx-auto 2xl:w-[90rem] 2xl:mb-[10rem] mt-10">



                            {
                                statsData.map((item, index) => (
                                    <div key={`divStat${item.name}${index}`} className={`widget text-[#333333] lg:text-[#FFB701] text-center p-4 lg:p-0 w-full sm:w-[15rem] lg:w-[12rem] xl:w-[16rem] 2xl:w-[326px] ${item.value !== '750,000+' && 'lg:!w-[9rem] xl:!w-[10rem]'} xl:mx-[2rem] lg:mx-[1rem]`}>
                                        {/* <img src={item.imgSrc} className="w-[73px] h-[68px] mx-auto sm:hidden" alt="" /> */}
                                        <div className="icon mb-2 sm:mb-0 w-[73px] h-[68px] mx-auto lg:hidden">
                                            {item.imgSrc2}
                                        </div>
                                        <h2 className='text-[40px] sm:text-[48px] font-[700] mb-1 2xl:text-[64px] 2xl:leading-[70px] 2xl:font-[800]'>{item.value}</h2>

                                        <div className="desc text-[24px] sm:text-[15px] mb-5 flex items-center justify-center text-sm 2xl:text-[18px] 2xl:leading-[40px]">
                                            {/* <img className={`object-contain hidden sm:block w-[1.2rem] mr-1 xl:w-[22px] 2xl:w-[29px] ${item.name === 'Global Clients' && 'lg:!w-[1.3rem]'}`} src={item.imgSrc} alt="" /> */}
                                            {item.imgSrc}
                                            <p className='text-[#333333] text-[24px] sm:text-[15px]'>{item.name}</p>
                                        </div>
                                    </div>
                                ))
                            }


                        </div>
                    </div>

                    {/* banner 4 */}
                    <div className="innerB  bg-[#333333] lg:mt-28 xl:mt-40 2xl:mt-5">

                        <div className="innerBWrapper h-[465px] sm:h-full  relative   py-10 flex justify-center lg:justify-between lg:w-[80vw] lg:mx-auto 2xl:h-[326px]">

                            <div className="left  w-full flex flex-col-reverse items-center lg:items-start sm:w-[40rem] lg:w-[30rem] 2xl:w-[682px] lg:justify-center">
                                <div className="wrapper flex flex-col items-center lg:items-start lg:justify-center">

                                    <h4 className='text-[#FFD700] text-[24px] sm:text-2xl font-bold text-center lg:text-left xl:text-[34px] xl:leading-[45px] 2xl:text-[44px] 2xl:leading-[55px] '>{toTitleCase("WORLD'S NO.1 GAMIFIED TESTS Company")}</h4>
                                    <Link to={"/free"}>

                                        <StyledButton btnText={"START FREE TRIAL"} customStyle=" !w-[13rem] !bg-[#FFD700] xl:!font-semibold !text-[#333333] !mt-4 sm:!mt-5 !h-[45px] !p-6 xl:w-[15rem] font-bold 2xl:!w-[20rem] lg:!mt-10 xl:h-[2rem] xl:font-bold xl:text-xs xl:!p-3 2xl:!h-[3.5rem] 2xl:!p-2 2xl:font-semibold lg:w-[13rem] lg:!p-2 hover:!bg-white hover:!text-[#333333] hover:!font-bold 2xl:!font-semibold 2xl:font-semibold 2xl:hover:!bg-white 2xl:hover:!text-[#333333] 2xl:hover:!font-semibold xl:hover:!bg-white xl:hover:!text-[#333333] xl:hover:!font-semibold lg:hover:!bg-white lg:hover:!text-[#333333] lg:hover:!font-semibold md:w-[14rem] md:!py-[1rem]" />
                                    </Link>
                                </div>
                            </div>
                            <div className="right visible sm:invisible lg:visible">
                                <img src={bannerArtScreen} className="sm:object-contain  h-[432px] w-[432px] sm:h-[16rem] lg:h-[400px] lg:w-[500px] lg:-top-[7.5rem] absolute -top-32 right-0  sm:-top-10 sm:right-40 xl:h-[500px] xl:w-[600px] 2xl:h-[600px] 2xl:w-[700px] xl:-top-[9rem] 2xl:-top-36 2xl:-right-[9rem] xl:-right-[94px] lg:-right-[97px]" alt="" />
                            </div>
                        </div>

                    </div>


                </div>

                <div className="pageEnd">

                    <svg viewBox="0 0 500 150" preserveAspectRatio="none" style={{ height: '10rem', width: '100%' }}><path d="M-3.76,53.79 C161.02,147.54 334.84,150.50 500.00,49.99 L500.00,0.00 L0.00,0.00 Z" style={{ stroke: 'none', fill: '#F7F7F7' }} /></svg>
                </div>
            </div>
        </Layout>
    )
}

export default About